import React, { useEffect, useState } from 'react';
import FasceOrarie from './FasceOrarie';
import ComponentList from './ComponentLista';
import CampiMenu from './CampiMenu';
import useEventForm from './hooks/useEventForm';
import axiosInstance from './services/axiosInstance';
import { BASE_URL } from './config';
import './CreaEvento.css';

const buildInitialData = (evento, aziendaId) => ({
  titolo: evento?.titolo || '',
  descrizione: evento?.descrizione || '',
  dataInizio: evento?.dataInizio ? evento.dataInizio.substring(0, 16) : '',
  dataFine: evento?.dataFine ? evento.dataFine.substring(0, 16) : '',
  prezzo: evento?.prezzo || 0,
  immagineCopertina: null,
  fileName: evento?.copertinaName || null,
  campiMenu: evento?.portate || [],
  categorie: evento?.categorie || [],
  fasceOrarie: evento?.fasceOrarie || [],
  idAzienda: evento?.idAzienda || aziendaId,
  posti: evento?.posti || 0,
});

const CreaMenu = ({ evento, azienda, onFormSubmit }) => {
  const { formData, setFormData, updateField, handleChange } = useEventForm(
    buildInitialData(evento, azienda)
  );
  const [lingue, setLingue] = useState([]);

  useEffect(() => {
    setFormData(buildInitialData(evento, azienda));
  }, [evento, azienda, setFormData]);

  useEffect(() => {
    axiosInstance.get('/lingue')
      .then((res) => setLingue(Array.isArray(res.data) ? res.data : []))
      .catch(() => setLingue([]));
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    onFormSubmit(formData);
  };

  return (
    <form onSubmit={handleSubmit}>
      <label>
        Titolo:
        <input type="text" name="titolo" value={formData.titolo} onChange={handleChange} />
      </label>
      <br />
      <label>
        Descrizione:
        <input
          type="text"
          name="descrizione"
          value={formData.descrizione}
          onChange={handleChange}
        />
      </label>
      <br />
      <label>
        Data di Inizio:
        <input type="date" name="dataInizio" value={formData.dataInizio} onChange={handleChange} />
      </label>
      <br />
      <label>
        Data di Fine:
        <input type="date" name="dataFine" value={formData.dataFine} onChange={handleChange} />
        <FasceOrarie
          onFasceOrarieChange={(fasceOrarie) => updateField('fasceOrarie', fasceOrarie)}
          initialFasceOrarie={formData.fasceOrarie}
        />
        <br />
      </label>
      <br />
      <label>
        Prezzo:
        <input
          type="number"
          name="prezzo"
          min="0"
          step="0.01"
          value={formData.prezzo}
          onChange={handleChange}
        />
      </label>
      <label>
        Posti disponibili:
        <input
          type="number"
          name="posti"
          min="0"
          value={formData.posti}
          onChange={handleChange}
        />
      </label>
      <br />
      <label>
        Immagine di copertina:
        <input type="file" name="immagineCopertina" accept="image/*" onChange={handleChange} />

        {/* In modifica la copertina gia' salvata non era mai visibile: si
            mostrava solo l'anteprima del file appena scelto, e del resto
            restava il solo nome file. /util/cover/{idEvento} la serve come
            immagine ed e' pubblico. */}
        {formData.immagineCopertina ? (
          <figure className="copertina-anteprima">
            <img src={formData.immagineCopertina} alt="Nuova copertina scelta" />
            <figcaption>Nuova immagine — sostituira' quella attuale al salvataggio</figcaption>
          </figure>
        ) : (
          evento?.id && (
            <figure className="copertina-anteprima">
              <img src={`${BASE_URL}/util/cover/${evento.id}`} alt="Copertina attuale" />
              <figcaption>
                Copertina attuale{formData.fileName ? ` — ${formData.fileName}` : ''}
              </figcaption>
            </figure>
          )
        )}
      </label>
      <br />
      <ComponentList
        onSelectedData={(selected) => {
          const ids = Array.isArray(selected) ? selected : [selected];
          updateField('categorie', ids);
        }}
        initialCategories={formData.categorie}
      />
      <br />
      <label>
        Lista portate
        <hr />
        <CampiMenu
          onCampiChange={(campiMenu) => updateField('campiMenu', campiMenu)}
          initialCampi={formData.campiMenu}
          lingue={lingue}
        />
      </label>
      <button type="submit">Invia</button>
    </form>
  );
};

export default CreaMenu;
